import * as React from 'react';

interface IProps {
    className?: string;
    onClick?: any;
}

class IconCircledLeftArrow extends React.Component<IProps> {
    public render() {
        return (
            <svg width="100" height="101" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg" className={this.props.className} onClick={this.props.onClick}>
                <g filter="url(#filter0_d)">
                    <rect x="80" y="80.7539" width="60" height="60" rx="30" transform="rotate(-180 80 80.7539)" fill="white" />
                    <path d="M47.1155 57.9654L39.9039 50.7539L47.1155 43.5424" stroke="#039BE5" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M61.5383 50.7539L39.9037 50.7539" stroke="#039BE5" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <filter id="filter0_d" x="0" y="0.753906" width="100" height="100" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="10" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    </filter>
                </defs>
            </svg>
        );
    }
}

export default IconCircledLeftArrow;
